// extracted by mini-css-extract-plugin
export var avatarContainer = "_ij-0";
export var avatarTypingWave = "_ij-i";
export var gray = "_ij-f";
export var green = "_ij-c";
export var icon = "_ij-9";
export var image = "_ij-1";
export var lg = "_ij-6";
export var md = "_ij-5";
export var presenceDot = "_ij-b";
export var red = "_ij-d";
export var sm = "_ij-4";
export var status = "_ij-a";
export var typingDot = "_ij-h";
export var typingPill = "_ij-g";
export var xl = "_ij-7";
export var xs = "_ij-3";
export var xxl = "_ij-8";
export var xxs = "_ij-2";
export var yellow = "_ij-e";